<template lang="pug">
  v-navigation-drawer.accent-4(
    style="background:#2537B4"
    dark
    permanent
    :mini-variant.sync="mini"
    app)
    v-img.mt-5.ml-6(      
      alt="NUFI",
      src="@/assets/logo_nufi_blanco-08.svg",
      transition="scale-transition",
      width="200"
      )
    br
    br
    v-list
      v-list-item(
        v-for="item in items"
        :key="item.title"        
        @click="$router.push(item.route)"
        )
        //- @click.stop="mini = !mini"
        v-list-item-avatar
          v-img(
            :src="require(`../../../assets/dashboard/${item.icon}`)",
            width="40"
          )
        v-list-item-content
          v-list-item-title.wrap-text
            v-text
              b {{ $t(item.title) }}    
    br
    br
    br
    br
    br    
    div.close-session
      v-list
        v-list-item(@click="logout")
          v-list-item-avatar
            v-img(
              src="@/assets/dashboard/Componentes-14.png",
              width="40")
          v-list-item-content
            v-list-item-title
              b {{ $t('logout') }}
      v-divider
      v-btn.locale-btn(
        text
        small @click="ChangeLocale").white--text {{(this.$i18n.locale === 'en')? 'Español' : 'English'}} 
</template>

<script>
export default {
  name: "NavigationTec",

  data() {
    return {
      items: [
        { title: "home", icon: "Componentes-06.png", route: "/technological/home" },
        { title: "documentation", icon: "Componentes-07.png", route: "/technological/documentation" },
        { title: "APIs", icon: "Componentes-08.png", route: "/technological/apis" },
        {
          title: "transactions",
          icon: "Componentes-09.png",
          route: "/technological/transactions",
        },
        { title: "roadmap", icon: "Componentes-10.png", route: "/technological/roadmap" },
        { title: "support", icon: "Componentes-11.png", route: "/technological/support" },
        { title: "monitor", icon: "Componentes-12.png", route: "/technological/monitor" },
        { title: "solutions", icon: "Componentes-17.png", route: "/technological/solutions" },
        { title: "profile", icon: "Componentes-13.png", route: "/technological/profile" },
      ],
      mini: false,
    };
  },
  methods: {
    logout() {    
      window.location.replace(process.env.VUE_APP_LOGIN);
    },
    ChangeLocale() {
      if(this.$i18n.locale === 'en') {
        this.$i18n.locale = 'es';
      } else {
        this.$i18n.locale = 'en';
      }
    }
  },  
};
</script>
<style scoped>
.close-session {
  /* position: absolute;
  bottom: 20px; */
  /* margin-top: 90%; */
  /* height: 30%; */
}
.v-divider {
  width: 85%;
  background-color: white;
  margin: auto;  
}
</style>